const home = {
  "home.tagline": "The Television That Connects You",
  "home.intro":
    "L+TV TÉLÉVISION is a premier Cameroonian television and digital media network based in Edea, delivering news, live broadcasts, programs, sports, entertainment, and cultural content to viewers across Cameroon and beyond.",
  "home.watchLive": "WATCH LIVE",
  "home.watchVideos": "WATCH VIDEOS",
  "home.scroll": "Scroll",
  "home.latestNews": "Latest News",
  "home.viewAllNews": "View All News",
  "home.featuredPrograms": "Featured Programs",
  "home.viewAllPrograms": "View All Programs",
  "home.latestVideos": "Latest Videos",
  "home.viewAllVideos": "View All Videos",
  "home.openLive": "Open Live TV",
  "home.offline": "L+TV is Currently Offline",
  "home.next": "Next",
  "home.presenter": "Presenter",
  "home.upNext": "Up Next",
  "home.connect": "Connect With L+TV",
  "home.connectDesc":
    "Follow L+TV on social media for the latest updates, live sessions, and behind-the-scenes content.",
  "home.subscribeTitle": "Stay Connected With L+TV",
  "home.subscribeDesc":
    "Subscribe to our newsletter for the latest news, program updates, and exclusive content delivered to your inbox.",
  "home.subscribeSuccess": "Thank You for Subscribing!",
  "home.subscribeSuccessDesc": "You will now receive updates from L+TV TÉLÉVISION.",
  "home.yourName": "Your Name",
  "home.yourEmail": "Your Email Address",
  "home.subscribe": "Subscribe",
  "home.bySubscribing":
    "By subscribing, you agree to receive emails from L+TV. You can unsubscribe at any time.",
  "home.featuredAnnouncements": "Featured Announcements",
  "home.sponsoredCampaigns": "Sponsored & special campaigns",
  "home.campaign": "Campaign",
  "home.learnMore": "Learn more",
  "home.breaking": "Breaking",
  "home.advertisement": "Advertisement",
  "home.latestNewsLabel": "Latest News",
  "home.welcome": "Welcome to L+TV — the television that connects you",
  "home.social.youtube": "YouTube",
  "home.social.youtubeDesc":
    "Subscribe to L+TV for full programs, news reports, and exclusive video content.",
  "home.social.youtubeCta": "Subscribe on YouTube",
  "home.social.facebook": "Facebook",
  "home.social.facebookDesc":
    "Follow our Facebook page for live updates, community discussions, and event coverage.",
  "home.social.facebookCta": "Follow on Facebook",
  "home.social.tiktok": "TikTok",
  "home.social.tiktokDesc":
    "Watch short videos, behind-the-scenes content, and viral moments from L+TV.",
  "home.social.tiktokCta": "Follow on TikTok",
  "newsletter.required": "Please enter both your name and email.",
  "newsletter.invalidEmail": "Please enter a valid email address.",
  "newsletter.error": "Something went wrong. Please try again.",
  "newsletter.welcomeSubject": "Welcome to our newsletter",
  "newsletter.welcomeBody": "Thank you for subscribing to L+TV TÉLÉVISION. You will now receive the latest news, program updates and exclusive content.",
};

export default home;